import React, { CSSProperties, ReactNode } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useDeleteLibraryTagsMutation } from '../../../generated/graphql';
import styles from './DeleteLibraryTagDialog.module.css';

type DeleteLibraryTagDialogProps = {
    onClose: () => void;
    tagId: string;
    id: string;
    visible: boolean;
    style?: CSSProperties;
    children?: ReactNode;
};

const DeleteLibraryTagDialog = ({ id, tagId, style, visible, onClose }: DeleteLibraryTagDialogProps) => {
    const [deleteLibraryTag, result] = useDeleteLibraryTagsMutation({
        variables: { id, ids: [tagId] },
    });

    const handleSubmit = async () => {
        try {
            await deleteLibraryTag();
        } finally {
            onClose();
        }
    };

    return (
        <DialogBase
            title="Delete Library Tag"
            type="OkCancel"
            isLoading={result.loading}
            visible={visible}
            onClose={onClose}
            onOkClick={handleSubmit}
            className={styles.DeleteLibraryTagDialog}
            style={style}
            data-testid="DeleteLibraryTagDialog"
        >
            <p style={{ color: 'var(--text-secondary)' }}>Are you sure you want to delete this Tag?</p>
        </DialogBase>
    );
};

export default DeleteLibraryTagDialog;
